import { cpf as cpfValidator} from 'cpf-cnpj-validator'

export const validateCPF = (cpf: string) => {
    return cpfValidator.isValid(cpf)
}